import { css, Notes, SelectInput, styled } from 'canoe';

export const PopoverTitle = styled(Notes)`
  ${({ theme }) => css`
    color: ${theme.colors.White};
    margin: 0 0 ${theme.spaces.xs} 0;
  `}
`;

export const PopoverContainer = styled.div`
  ${({ theme }) => css`
    width: 316px;
    background-color: ${theme.colors.OnyxGrayD10};
    padding: ${theme.spaces.s};
    border-radius: ${theme.borderRadius.small};
  `}
`;

export const CollectionSelectInput = styled(SelectInput)<{ hasError: boolean }>`
  ${({ theme, hasError }) => css`
    height: 32px;
    ${hasError &&
    css`
      outline: 1px solid ${theme.colors.Danger};
    `}
  `}
`;
